import React from 'react'
import { connect } from 'react-redux'
import { getFormValue, hasChangedValues } from '../../public/utility/formValues'

class SupplierKindItemDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { id, classID } = this.props
        Tyan.doPostEvent({
            event: 'GetSupplierKindItem',
            data: { id, classID },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ initValues基本信息, optionsParas })
            }
        })
    }

    handlerSave = () => {
        const { changedValues基本信息 } = this.state
        const { onSave, onClose, id, classID } = this.props
        Tyan.doPostEvent({
            event: 'SaveSupplierKindItem',
            data: { id, classID, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                onSave && onSave()
                onClose && onClose()
            }
        })
    }

    handlerDelete = () => {
        const { onSave, onClose, id } = this.props
        Tyan.pubForm.showConfirm('确定要删除分类方式？', () =>
            Tyan.doPostEvent({
                event: 'DeleteSupplierKindItem',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '分类名称')
    }

    fieldset基本信息 = () => {
        return [
            { _text: '分类名称', minWidth: '95%', required: true },
            { _select: '所属分类方式', minWidth: '95%', },
            { _int: '排序', minWidth: '90%', textAlign: 'left' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="600"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(SupplierKindItemDiv)